import { render, staticRenderFns } from "./standIndustry.vue?vue&type=template&id=74767607&scoped=true"
import script from "./standIndustry.vue?vue&type=script&lang=js"
export * from "./standIndustry.vue?vue&type=script&lang=js"
import style0 from "./standIndustry.vue?vue&type=style&index=0&id=74767607&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74767607",
  null
  
)

export default component.exports